import MiMenuManagement from './menu';
import { install } from '../../../utils/install';
export default install(MiMenuManagement);
